import { api } from "./auth";

/**
 * Create a new trip
 * @param {Object} tripData - Trip details
 */
export async function createTrip(tripData) {
  const response = await api.post("/trips/", tripData);
  return response.data;
}

/**
 * Get all my trips
 * @param {string} status - Filter by status: 'planning', 'active', 'completed', 'cancelled'
 */
export async function getMyTrips(status = null) {
  const url = status ? `/trips/my-trips?status=${status}` : "/trips/my-trips";
  const response = await api.get(url);
  return response.data;
}

/**
 * Get a specific trip by ID
 * @param {number} tripId - Trip ID
 */
export async function getTripById(tripId) {
  const response = await api.get(`/trips/${tripId}`);
  return response.data;
}

/**
 * Update a trip
 * @param {number} tripId - Trip ID
 * @param {Object} tripData - Updated trip data
 */
export async function updateTrip(tripId, tripData) {
  const response = await api.put(`/trips/${tripId}`, tripData);
  return response.data;
}

/**
 * Delete a trip
 * @param {number} tripId - Trip ID
 */
export async function deleteTrip(tripId) {
  const response = await api.delete(`/trips/${tripId}`);
  return response.data;
}

/**
 * Search partners by trip destination and status
 * @param {string} destination - Destination to search for
 * @param {string} tripStatus - Trip status filter
 */
export async function searchPartnersByTrip(destination, tripStatus = 'planning') {
  const response = await api.get(`/trips/search/partners`, {
    params: { destination, trip_status: tripStatus }
  });
  return response.data;
}

/**
 * Get all partners (with trips)
 */
export async function getAllPartners(skip = 0, limit = 100) {
  const response = await api.get("/partners/", {
    params: { skip, limit }
  });
  return response.data;
}

/**
 * Search partners
 * @param {Object} filters - Search filters
 */
export async function searchPartners(filters = {}) {
  const response = await api.get("/partners/search", { params: filters });
  return response.data;
}
